module.exports = __webpack_public_path__ + "static/media/drs3.png.3a04867b.jpg";